import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'

require('./axios');
// Globally Registered Components
import './globalComponents.js'

// Theme styles
import './assets/css/theme-main.css';

// Custom styles
import './assets/css/custom-style.css';
import 'material-icons/iconfont/material-icons.css' // Material Icons
import 'vuesax/dist/vuesax.css' // Vuesax
import './assets/scss/wizard.scss'; // Wizard
//import './assets/css/select2.css'; // Select2

import axiosHelper from "./components/mixins/axiosHelper";
import notificationsHelper from "./components/mixins/notificationsHelper";
Vue.mixin(axiosHelper)
Vue.mixin(notificationsHelper)

Vue.config.productionTip = false

import {mapState, mapMutations} from "vuex";

/*import { vsPrompt, vsPopup, vsButton, vsIcon } from 'vuesax'
Vue.use(vsPrompt)
Vue.use(vsPopup)
Vue.use(vsButton)
Vue.use(vsIcon)*/

import Vuesax from 'vuesax'
Vue.use(Vuesax, {});

import interceptors from "./http/interceptors";
interceptors();

Vue.mixin({
  methods: {
    async redirectToLogin(){
      await this.$router.push({name: 'login'});
    },
    showLoader(text = null){
      this.$store.commit("SET_LOADER_ACTIVE", text)
    },
    stopLoader(){
      this.$store.commit("SET_LOADER_INACTIVE")
    }
  }
})

new Vue({
  render: h => h(App),
  router,
  store,
  computed: {
    ...mapState("auth", ["user", "access_token", "is_logged"]),
  },
  watch: {
    // escuchar si el usuario deja de estar autenticado (error 401)
    async '$store.state.isUnauthenticated'(val){
      if(!val){
        return;
      }
      
      // limpiar los datos del carrito de compras
      this.cleanCart();
      // limpiar los datos de sesion
      this.cleanSession();
      // enviar al usuario a la pantalla de login
      await this.redirectToLogin();
    }
  },
  created : function () {
    // verificar si se tiene un token desde localStorage
    if(this.access_token != null && this.access_token != null){
      this.setAxiosAccessToken(this.access_token);
    }
  },
  methods: {
    ...mapMutations("auth", ["cleanSession"]),
    ...mapMutations("cart", ["cleanCart"]),
    setAxiosAccessToken(token){
      window.axios.defaults.headers.common['X-AUTH-TOKEN'] = token;
    },
    
  },
}).$mount('#app')
